import { Transition } from "@headlessui/react";
import HomeIcon from "@heroicons/react/outline/HomeIcon";
import { FC } from "react";

interface Props {
  loading: boolean;
}

const Loader: FC<Props> = ({ loading }) => (
  <Transition show={loading}>
    <div className="fixed flex justify-center items-center inset-0 z-30">
      <Transition.Child
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-30"
        leave="ease-in duration-200"
        leaveFrom="opacity-30"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black/30" />
      </Transition.Child>

      <Transition.Child
        enter="ease-out duration-300"
        enterFrom="opacity-0 scale-90"
        enterTo="opacity-100 scale-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-90"
      >
        <div className="animate-spin-slow w-40 h-40 rounded-full">
          <HomeIcon className="h-full w-full text-black rounded-full -translate-y-4 bg-transparent" />
        </div>
        <button />
      </Transition.Child>
    </div>
  </Transition>
);

export default Loader;
